import { render } from "./OrderDetial.vue?vue&type=template&id=4a5f3f4b&scoped=true"
import script from "./OrderDetial.vue?vue&type=script&lang=js"
export * from "./OrderDetial.vue?vue&type=script&lang=js"

import "./OrderDetial.vue?vue&type=style&index=0&id=4a5f3f4b&scoped=true&lang=css"

import exportComponent from "/Users/dejth/Workspace/nakee-order-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5f3f4b"]])

export default __exports__